import { ActionIcon, Checkbox, Group, NumberInput, TextInput } from '@mantine/core';
import { IconGripVertical, IconTrash } from '@tabler/icons-react';

export interface CustomFieldRowProps {
  fieldKey: string;
  label: string;
  required: boolean;
  maxLength: number;
  editing: boolean;
  onChange: (next: {
    fieldKey: string;
    label: string;
    required: boolean;
    maxLength: number;
  }) => void;
  onRemove: () => void;
  dragHandleProps?: Record<string, unknown>;
}

const FIELD_KEY_REGEX = /^[a-z][a-z0-9_]{0,62}$/;

export function CustomFieldRow(props: CustomFieldRowProps) {
  const keyValid = FIELD_KEY_REGEX.test(props.fieldKey);
  return (
    <Group gap="xs" wrap="nowrap" align="flex-start">
      <ActionIcon
        variant="subtle"
        size="lg"
        disabled={!props.editing}
        aria-label="Drag to reorder"
        {...props.dragHandleProps}
      >
        <IconGripVertical size={16} />
      </ActionIcon>
      <TextInput
        label="field_key"
        value={props.fieldKey}
        disabled={!props.editing}
        error={
          props.editing && props.fieldKey && !keyValid
            ? 'must match /^[a-z][a-z0-9_]{0,62}$/'
            : undefined
        }
        onChange={(e) =>
          props.onChange({ ...currentValues(props), fieldKey: e.currentTarget.value })
        }
        w={200}
      />
      <TextInput
        label="Label"
        value={props.label}
        disabled={!props.editing}
        onChange={(e) => props.onChange({ ...currentValues(props), label: e.currentTarget.value })}
        w={220}
      />
      <Checkbox
        label="Required"
        checked={props.required}
        disabled={!props.editing}
        onChange={(e) =>
          props.onChange({ ...currentValues(props), required: e.currentTarget.checked })
        }
        mt={26}
      />
      <NumberInput
        label="Max length"
        value={props.maxLength}
        min={1}
        max={10000}
        disabled={!props.editing}
        onChange={(v) =>
          props.onChange({ ...currentValues(props), maxLength: typeof v === 'number' ? v : 1000 })
        }
        w={120}
      />
      <ActionIcon
        variant="subtle"
        color="red"
        size="lg"
        disabled={!props.editing}
        onClick={props.onRemove}
        aria-label="Remove field"
        mt={26}
      >
        <IconTrash size={16} />
      </ActionIcon>
    </Group>
  );
}

function currentValues(props: CustomFieldRowProps) {
  return {
    fieldKey: props.fieldKey,
    label: props.label,
    required: props.required,
    maxLength: props.maxLength,
  };
}
